import { useLingui } from '@lingui/react/macro';

import { MobileBrandFilter } from '@/components/SharedFilters/BrandFilter/MobileBrandFilter';
import { useSettingsScope } from '@/routes/SettingsBeta/SettingsContext';

import { useFilters } from '../FiltersState';

export const FiltersBrand = () => {
  const { t } = useLingui();
  const { scope } = useSettingsScope();
  const organizationId = scope?.scope === 'organization' ? scope.organizationId : undefined;

  const {
    brands: { brands, setBrands },
  } = useFilters();

  return (
    <MobileBrandFilter
      filterId="product-brand"
      selectedBrands={brands}
      setSelectedBrands={setBrands}
      brandsQuery={{ organizationId, limit: 500, offset: 0 }}
      label={t({
        id: 'settings.organization.data-catalogs.products.filters.brand.label',
        message: 'Brand',
      })}
    />
  );
};
